<template>
    <v-container>
        <v-card>
            <v-card-title>
                <span class="headline">{{ $t('ConfigAlertFailMessage')|capitalize }}</span>
            </v-card-title>
            <v-card-text>
                <v-layout align-center justify-center row>
                    <v-flex>
                        <v-layout column>
                            <v-flex class="mb-2">
                                <v-text-field 
                                    placeholder="Emails" 
                                    type="text"
                                    ref="alertEmailFailedMessage" 
                                    outline 
                                    solo 
                                    dense 
                                    flat 
                                    style="font-size: 14px"
                                    v-model="alert_email_failed_message" 
                                    @change="checkEmailFormat"
                                    :rules="[v => !!v || $t('fieldCannotBeEmpty')]">

                                </v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <div class="align-self-end">
                    <v-btn class="ma-0 text-none" color="primary" depressed type="submit" @click="submitConfig">{{ $t('save')|capitalize }}</v-btn>
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
    import BotService from "@/services/bot.service";

export default {
    name: "ConfigAlertFailMessage",
    props: {
        botCode: String,
    },
    data() {
        return {
            alert_email_failed_message: "",
        }
    },
    mounted() {
        if (this.botCode) {
            this.fetchConfig();
        }
    },

    watch: {
        botCode() {
            if (this.botCode) {
                this.fetchConfig();
            }
        },
    },

    methods: {
        async fetchConfig() {
            try {
                const response = await BotService.getConfigAlertFailedMessage(this.botCode);
                this.alert_email_failed_message = response.data.join(",");
            } catch (error) {
                console.error("Error fetching config:", error);
            }
        },
        checkEmailFormat() {
            // strip whitespace and validate email format
            this.alert_email_failed_message = this.alert_email_failed_message.trim();
            const emails = this.alert_email_failed_message.split(",");
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            for (const email of emails) {
                if (!emailRegex.test(email)) {
                    this.$AppService.toastError(this.$t('invalidEmailFormat'));
                    return false;
                }
            }
            return true;
        },

        async submitConfig() {
            // strip whitespace and validate email format
            if (!this.checkEmailFormat()) {
                return;
            }

            try {
                await BotService.updateConfigAlertFailedMessage(this.botCode, this.alert_email_failed_message.split(","));
                this.$AppService.toastSuccess(this.$t('updateSuccess'));
            } catch (error) {
                console.error("Error updating config:", error);
                this.$AppService.toastError(this.$t('updateFailed'));
            }
        },
    },
}
</script>

<style scoped lang="scss">
.title {
  font-size: 18px !important;
}
::v-deep .v-text-field--outline>.v-input__control>.v-input__slot {
  min-height: 34px !important;
}
::v-deep.v-text-field--outline input {
  margin: 0 !important;
}
::v-deep.theme--light.v-text-field--outline>.v-input__control>.v-input__slot {
  border: 1px solid #D9D9D9 !important;
  border-radius: 5px;
}
.input {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.input:focus {
  outline: none !important;
}
</style>
